<div
  class="way-purchase-layout way-purchase-active-subscription-layout"
  [class.way-purchase-layout--unavailable]="isUnavailable"
  *ngIf="isVisible && displayVm"
>
  <div *ngIf="isUnavailable" class="way-purchase-layout__unavailable">
    <span *ngIf="showUnredeemableBadge" class="way-purchase-layout__unavailable-badge">Unredeemable</span>
    <span *ngIf="showAlreadyRedeemedInfoChip" class="way-purchase-layout__info-chip">{{ unavailableReason }}</span>
    <p *ngIf="showUnredeemableBadge" class="way-purchase-layout__unavailable-reason">{{ unavailableReason }}</p>
  </div>

  <div class="way-purchase-layout__grid">
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Customer Name</label>
      <p class="way-purchase-layout__value">{{ displayVm.customerName }}</p>
    </div>
    <div
      class="way-purchase-layout__field"
      [class.way-purchase-layout__plate-field--required]="needsPlateEntry"
    >
      <label class="way-purchase-layout__label" for="way-membership-plate">Vehicle License Plate</label>
      <ng-container *ngIf="needsPlateEntry; else membershipPlateReadonly">
        <input
          matInput
          id="way-membership-plate"
          type="text"
          class="way-purchase-layout__plate-input"
          [ngModel]="plateInput"
          (ngModelChange)="onPlateInput($event)"
          [disabled]="plateInputDisabled"
          [class.p-invalid]="!!plateInputError"
          autocomplete="off"
          autocapitalize="characters"
          spellcheck="false"
         
          [attr.aria-invalid]="!!plateInputError"
          [attr.aria-describedby]="plateInputError ? 'way-membership-plate-error' : null"
        />
        <small
          *ngIf="plateInputError"
          id="way-membership-plate-error"
          class="p-error"
          role="alert"
        >
          {{ plateInputError }}
        </small>
      </ng-container>
      <ng-template #membershipPlateReadonly>
        <p class="way-purchase-layout__value">{{ displayVm.licensePlate }}</p>
      </ng-template>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Package Name</label>
      <p class="way-purchase-layout__value">{{ displayVm.packageName }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Total Washes Available</label>
      <p class="way-purchase-layout__value">{{ displayVm.totalWashesAvailableDisplay }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Total Washes Redeemed</label>
      <p class="way-purchase-layout__value">{{ displayVm.totalWashesRedeemedDisplay }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Last Washed Date</label>
      <p class="way-purchase-layout__value">{{ displayVm.lastWashedDateDisplay }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Status</label>
      <p class="way-purchase-layout__value">{{ displayVm.statusLabel }}</p>
    </div>
    <div class="way-purchase-layout__field">
      <label class="way-purchase-layout__label">Purchased Through</label>
      <p class="way-purchase-layout__value">{{ displayVm.channelLabel }}</p>
    </div>
  </div>
</div>
